import { useState, useMemo } from 'react'
import {
	EuiButton,
	EuiPopoverTitle,
	EuiPopover,
} from '@equipmentshare/ds2'
import OutgoingTable from '../OutgoingTable'

import { OutgoingTransferDetail as GqlOutgoingTransferDetail } from '../../../../../graphql'

export type OutgoingTransfer = Pick<GqlOutgoingTransferDetail, 'transferOrderId' | 'quantity'>

export type OutgoingPopoverProps = {
	transfers: OutgoingTransfer[],
}

export default function OutgoingPopover( { transfers }: OutgoingPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const quantity = useMemo( () => transfers.reduce( ( total, transfer ) => total + transfer.quantity, 0 ), [ transfers ] )

	if ( quantity === 0 ) {
		return null
	}

	const button = (
		<EuiButton
			color="text"
			onClick={() => setIsPopoverOpen( ( prev ) => !prev )}
			size="s"
		>
			{quantity} {quantity === 1 ? 'item' : 'items'}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={() => setIsPopoverOpen( false )}
		>
			<EuiPopoverTitle>Outgoing</EuiPopoverTitle>
			<OutgoingTable transfers={transfers} />
		</EuiPopover>
	)
}
